<template>
    <button 
        v-if="tooltip" 
        v-tippy="tooltip" 
        :class="buttonClasses" 
        :disabled="disabled"
    >
        <slot />
    </button>
    <button 
        v-else 
        :class="buttonClasses" 
        :disabled="disabled"
    >
        <slot />
    </button>
</template>

<script>
export default {
    props: {
        tooltip: {
            type: String,
            default: ''
        },
        red: {
            type: Boolean,
            default: false
        },
        green: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        buttonClasses() {
            return `${this.disabled ? 'opacity-50 cursor-not-allowed' : ''} ${
                this.red
                    ? 'inline-flex items-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-xs font-semibold uppercase tracking-widest text-white transition duration-150 ease-in-out hover:bg-red-500 focus:bg-red-500 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-offset-2 active:bg-red-700'
                    : this.green
                    ? 'inline-flex items-center rounded-md border border-transparent bg-green-600 px-4 py-2 text-xs font-semibold uppercase tracking-widest text-white transition duration-150 ease-in-out hover:bg-green-500 focus:bg-green-500 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-offset-2 active:bg-green-700'
                    : 'inline-flex items-center rounded-md border border-transparent bg-gray-800 px-4 py-2 text-xs font-semibold uppercase tracking-widest text-white transition duration-150 ease-in-out hover:bg-gray-700 focus:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 active:bg-gray-900'
            }`;
        }
    }
};
</script>
